import React from 'react';
import { SampleDataProvider } from './expressionEditor/SampleDataContext';

/**
 * This wrapper provides the SampleDataProvider to the workflow editing components.
 * It should be placed high enough in the component tree to wrap all components
 * that need access to sample data.
 */
const WorkflowEditorWrapper = ({ children }) => {
    return (
        <SampleDataProvider>
            {children}
        </SampleDataProvider>
    );
};

export default WorkflowEditorWrapper;
